export enum Index {
  USER = 'user',
  ACTIVITY = 'activity',
  AUDIT = 'audit',
  MESSAGE = 'message',
  TENANT = 'tenant',
  STORE = 'store',
  CHECKOUT = 'checkout',
  SYSTEM = 'system',
  SURVEY = 'survey'
}
